import Vue from 'vue'
import Router from 'vue-router'

//做分页功能时，push路由时报错，此为解决方法
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
	mode: 'history',
	linkActiveClass: 'active',
	routes: [{
		path: '/login',
		name: 'LoginPage',
		meta: {
			NoRequireAuth: true,			//设置为 true 代表不登录也可查看，不设置代表必须登录才可以查看
			title: '禾场后台-登录'
		},
		component: resolve => require(['@/components/login/LoginPage'], resolve),
	},{
		path: '/upyun-upload-test',
		name: 'upyunUploadTest',
		meta: {
			NoRequireAuth: true,
			title: 'upyun上传测试'
		},
		component: resolve => require(['@/components/test/UpyunUploadTest'], resolve),
	},{
		path: '/',
		name: 'roots',
		component: resolve => require(['../components/rootsPage.vue'], resolve),
		children: [{
			path: '',
			name: 'HomePage',
			redirect: to => {
		      // return 重定向的字符串路径/路径对象
		      return { path: '/admin/dashboard/operation'}
		    },
		},{
			path: '/admin/dashboard',
			component: resolve => require(['@/components/indexModule'], resolve),
			children: [{
				path: '',
				redirect: to => {
			      return { path: '/admin/dashboard/operation'}
			    },
			},{
				path: 'sale',			//销售动态
				name: 'Sale',
				meta:{
					bg:'bg-gray',
					menu:'sale',
					title:'销售动态-禾场后台',
//					group_key:'',
//					permission_key:'',
				},
				component: resolve => require(['@/components/dashboard/sale'], resolve),
			},{
				path: 'operation',			//运营管理
				name: 'Operation',
				meta:{
					bg:'bg-gray',
					menu:'operation',
					title:'运营管理-禾场后台',
//					group_key:'',
//					permission_key:'',
				},
				component: resolve => require(['@/components/dashboard/operation'], resolve),
			},{
				path: 'settings',			//后台设置
				name: 'Settings',
				meta:{
					bg:'bg-gray',
					menu:'settings',
					title:'后台设置-禾场后台',
//					group_key:'',
//					permission_key:'',
				},
				component: resolve => require(['@/components/dashboard/settings'], resolve),
			}]
		},{
			path: '/admin/dashboard/sale',
			component: resolve => require(['@/components/indexModule'], resolve),
			children: [{
				path: '',			//销售动态
				name: 'Sale',
				meta:{
					bg:'bg-gray',
					menu:'sale',
					title:'销售动态-禾场后台',
//					group_key:'',
//					permission_key:'',
				},
				component: resolve => require(['@/components/dashboard/sale'], resolve),
			},{
				path: 'increment-users-list/:type',			//销售动态
				name: 'Sale',
				meta:{
					bg:'bg-gray',
					menu:'sale',
					title:'用户增员列表',
					group_key:'',
					permission_key:'increment-users',
				},
				component: resolve => require(['@/components/salePart/IncrementUserList'], resolve),
			},{
				path: 'live-audience',
				name: 'LiveAudience',
				meta:{
					bg:'bg-gray',
					title:'直播观众列表',
					group_key:'',
					permission_key:'live-audience',
					menu:'sale',
					// bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/roles","title":"管理角色"},{"url":"","title":"设置角色权限"}],
				},
				component: resolve => require(['@/components/liveAudience/liveAudiencePage'], resolve),
			}]
		},{
			path: '/admin/roles',
			component: resolve => require(['@/components/indexModule'], resolve),
			children: [{
				path: '',
				name: 'rolePage',
				meta:{
					bg:'bg-gray',
					title:'管理角色',
					group_key:'',
					permission_key:'roles',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"管理角色"}],
				},
				component: resolve => require(['../components/roles/rolePage'], resolve),
			},{
				path: ':id/permissions',
				name: 'rolePermissions',
				meta:{
					bg:'bg-gray',
					title:'设置角色权限',
					group_key:'',
					permission_key:'role-permissions',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/roles","title":"管理角色"},{"url":"","title":"设置角色权限"}],
				},
				component: resolve => require(['@/components/roles/permissions/rolePermissions'], resolve),
			}]
		},{
			path: '/admin/user',
			component: resolve => require(['@/components/indexModule'], resolve),
			children: [{
				path: '',
				name: 'userList',
				meta:{
					bg:'bg-gray',
					title:'用户列表',
					group_key:'',
					permission_key:'users',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"用户列表"}],
				},
				component: resolve => require(['@/components/user/userList'], resolve),
			},{
				path: ':id/setting',
				name: 'memberSetting',
				meta:{
					bg:'bg-gray',
					title:'设置会员类型',
					group_key:'',
					permission_key:'member-settings-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/user","title":"用户列表"},{"url":"","title":"设置会员类型"}],
				},
				component: resolve => require(['@/components/member/setting/memberSetting'], resolve),
			},{
				path: 'add',
				name: 'userAdd',
				meta:{
					bg:'bg-gray',
					title:'生成用户',
					group_key:'',
					permission_key:'user-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/user","title":"用户列表"},{"url":"","title":"生成用户"}],
				},
				component: resolve => require(['@/components/user/userAdd'], resolve),
			},{
				path: ':id/edit',
				name: 'userEdit',
				meta:{
					bg:'bg-gray',
					title:'编辑用户',
					group_key:'',
					permission_key:'user-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/user","title":"用户列表"},{"url":"","title":"编辑用户"}],
				},
				component: resolve => require(['@/components/user/userEdit'], resolve),
			},{
				path: ':id/coin',
				name: 'userEdit',
				meta:{
					bg:'bg-gray',
					title:'禾豆设置',
					group_key:'',
					permission_key:'coin-settings',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/user","title":"用户列表"},{"url":"","title":"禾豆设置"}],
				},
				component: resolve => require(['@/components/user/coin/userCoinAdd'], resolve),
			},{
				path: ':id/address',
				name: 'userAddress',
				meta:{
					bg:'bg-gray',
					title:'收货地址',
					group_key:'',
					permission_key:'shipping-addresses',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/user","title":"用户列表"},{"url":"","title":"收货地址"}],
					type:'user',				//用户列表和会员列表都有做这个页面，此值为了区分两个列表跳转的面包屑
				},
				component: resolve => require(['@/components/user/userAddress/userAddress'], resolve),
			},{
				path: ':uid/consumption',
				name: 'memberConsumption',
				meta:{
					bg:'bg-gray',
					title:'用户详情',
					group_key:'',
					permission_key:'member-consumption',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/user","title":"用户列表"},{"url":"","title":"用户详情"}],
				},
				component: resolve => require(['../components/member/consumption/memberConsumption'], resolve),
			},{
				path: ':uid/address/add',
				name: 'userAddressAdd',
				meta:{
					bg:'bg-gray',
					title:'新增收货地址',
					group_key:'',
					permission_key:'shipping-address-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/user","title":"用户列表"}],
					type:'user',				//用户列表和会员列表都有做这个页面，此值为了区分两个列表跳转的面包屑
				},
				component: resolve => require(['@/components/user/userAddress/userAddressAdd'], resolve),
			},{
				path: ':uid/address/:aid/edit',
				name: 'userAddressEdit',
				meta:{
					bg:'bg-gray',
					title:'编辑收货地址',
					group_key:'',
					permission_key:'shipping-address-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/user","title":"用户列表"}],
					type:'user',				//用户列表和会员列表都有做这个页面，此值为了区分两个列表跳转的面包屑
				},
				component: resolve => require(['@/components/user/userAddress/userAddressEdit'], resolve),
			},{
				path: ':uid/buy-product',
				name: 'memberBuyProduct',
				meta:{
					bg:'bg-gray',
					title:'后台下单',
					group_key:'',
					permission_key:'entity-order-create',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/user","title":"用户列表"},{"url":"","title":"后台下单"}],
					type:'user',				//用户列表和会员列表都有做这个页面，此值为了区分两个列表跳转的面包屑
				},
				component: resolve => require(['../components/member/buy-product/memberBuyProduct'], resolve),
			},{
				path: ':id/invoices',
				name: 'userInvoices',
				meta:{
					bg:'bg-gray',
					title:'发票信息',
					group_key:'',
					permission_key:'invoices',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/user","title":"用户列表"},{"url":"","title":"发票信息"}],
					type:'user',				//用户列表和会员列表都有做这个页面，此值为了区分两个列表跳转的面包屑
				},
				component: resolve => require(['@/components/user/userInvoices/userInvoices'], resolve),
			},{
				path: ':uid/invoice/add',
				name: 'userInvoicesAdd',
				meta:{
					bg:'bg-gray',
					title:'新增发票信息',
					group_key:'',
					permission_key:'invoice-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/user","title":"用户列表"}],
					type:'user',				//用户列表和会员列表都有做这个页面，此值为了区分两个列表跳转的面包屑
				},
				component: resolve => require(['@/components/user/userInvoices/userInvoicesAdd'], resolve),
			},{
				path: ':uid/invoice/:vid/edit',
				name: 'userInvoicesEdit',
				meta:{
					bg:'bg-gray',
					title:'编辑发票信息',
					group_key:'',
					permission_key:'invoice-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/user","title":"用户列表"}],
					type:'user',				//用户列表和会员列表都有做这个页面，此值为了区分两个列表跳转的面包屑
				},
				component: resolve => require(['@/components/user/userInvoices/userInvoicesEdit'], resolve),
			}]
		},{
			path: '/admin/section',
			component: resolve => require(['@/components/indexModule'], resolve),
			children: [{
				path: '',
				name: 'sectionsList',
				meta:{
					bg:'bg-gray',
					title:'课节列表',
					group_key:'',
					permission_key:'sections',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"课节列表"}],
				},
				component: resolve => require(['@/components/sections/sectionsList'], resolve),
			},{
				path: 'add',
				name: 'sectionsAdd',
				meta:{
					bg:'bg-gray',
					title:'发布课节',
					group_key:'',
					permission_key:'section-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"发布课节"}],
				},
				component: resolve => require(['@/components/sections/sectionAddOrEdit/sectionAdd'], resolve),
			},{
				path: ':id/edit',
				name: 'sectionsEdit',
				meta:{
					bg:'bg-gray',
					title:'编辑课节',
					group_key:'',
					permission_key:'section-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/section","title":"课节列表"},{"url":"","title":"编辑课节"}],
				},
				component: resolve => require(['@/components/sections/sectionAddOrEdit/sectionEdit'], resolve),
			}]
		},{
			path: '/admin/course',
			component: resolve => require(['@/components/indexModule'], resolve),
			children: [{
				path: '',
				name: 'courseList',
				meta:{
					bg:'bg-gray',
					title:'课程列表',
					group_key:'',
					permission_key:'courses',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"课程列表"}],
				},
				component: resolve => require(['@/components/course/courseList'], resolve),
			},{
				path: 'banner',
				name: 'CourseBanner',
				meta:{
					bg:'bg-gray',
					title:'课程 Banner',
					group_key:'',
					permission_key:'course-banners',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"课程 Banner"}],
				},
				component: resolve => require(['@/components/course/banner/courseBanner'], resolve),
			},{
				path: 'banner/add',
				name: 'CourseBannerAdd',
				meta:{
					bg:'bg-gray',
					title:'添加课程 Banner',
					group_key:'',
					permission_key:'course-banner-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/course/banner","title":"课程 Banner"},{"url":"","title":"添加课程 Banner"}],
				},
				component: resolve => require(['@/components/course/banner/courseBannerAdd'], resolve),
			},{
				path: 'banner/:id/edit',
				name: 'CourseBannerEdit',
				meta:{
					bg:'bg-gray',
					title:'编辑课程 Banner',
					group_key:'',
					permission_key:'course-banner-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/course/banner","title":"课程 Banner"},{"url":"","title":"编辑课程 Banner"}],
				},
				component: resolve => require(['@/components/course/banner/courseBannerEdit'], resolve),
			},{
				path: ':cid/coupon',
				name: 'courseCoupon',
				meta:{
					bg:'bg-gray',
					title:'课程抵用券',
					group_key:'',
					permission_key:'course-coupons',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/course","title":"课程列表"},{"url":"","title":"课程抵用券"}],
				},
				component: resolve => require(['../components/course/coupon/courseCoupon'], resolve),
			},{
				path: ':cid/coupon/add',
				name: 'courseCouponAdd',
				meta:{
					bg:'bg-gray',
					title:'生成抵用券',
					group_key:'',
					permission_key:'course-coupon-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/course/coupon","title":"课程抵用券"},{"url":"","title":"生成抵用券"}],
				},
				component: resolve => require(['../components/course/coupon/courseCouponAdd'], resolve),
			},{
				path: ':cid/join',
				name: 'courseJoin',
				meta:{
					bg:'bg-gray',
					title:'添加成员',
					group_key:'',
					permission_key:'course-addition',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/course","title":"课程列表"},{"url":"","title":"添加成员"}],
				},
				component: resolve => require(['../components/course/join/courseJoin'], resolve),
			},{
				path: ':cid/setting',
				name: 'courseSetting',
				meta:{
					bg:'bg-gray',
					title:'课程设置',
					group_key:'',
					permission_key:'course-settings',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/course","title":"课程列表"},{"url":"","title":"课程设置"}],
				},
				component: resolve => require(['../components/course/setting/courseSetting'], resolve),
			},{
				path: ':cid/member',
				name: 'courseMember',
				meta:{
					bg:'bg-gray',
					title:'订购名单',
					group_key:'',
					permission_key:'course-members',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/course","title":"课程列表"},{"url":"","title":"订购名单"}],
				},
				component: resolve => require(['../components/course/member/courseMembers'], resolve),
			},{
				path: 'add',
				name: 'CourseAdd',
				meta:{
					bg:'bg-gray',
					title:'发布课程',
					group_key:'',
					permission_key:'course-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"发布课程"}],
				},
				component: resolve => require(['@/components/course/CourseAddOrEdit/courseAdd'], resolve),
			},{
				path: ':id/edit',
				name: 'CourseEdit',
				meta:{
					bg:'bg-gray',
					title:'课程编辑',
					group_key:'',
					permission_key:'course-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/course","title":"课程列表"},{"url":"","title":"课程编辑"}],
				},
				component: resolve => require(['@/components/course/CourseAddOrEdit/courseEdit'], resolve),
			},{
				path: ':id/course-collections',
				name: 'CourseCollections',
				meta:{
					bg:'bg-gray',
					title:'目录',
					group_key:'',
					permission_key:'course-collections',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/course","title":"课程列表"},{"url":"","title":"目录"}],
				},
				component: resolve => require(['@/components/course/Collections/courseCollections'], resolve),
			},{
				path: ':id/collections/:cid',
				name: 'CourseCollectionsEdit',
				meta:{
					bg:'bg-gray',
					title:'关联课节',
					group_key:'',
					permission_key:'course-collection-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/course","title":"课程列表"}],
				},
				component: resolve => require(['@/components/course/Collections/courseCollectionsAdd'], resolve),
			}]
		},{
			path: '/admin/shop',
			component: resolve => require(['@/components/indexModule'], resolve),
			children: [{
				path: '',
				name: 'shopList',
				meta:{
					bg:'bg-gray',
					title:'商店',
					group_key:'',
					permission_key:'products',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"商店"}],
				},
				component: resolve => require(['@/components/shop/shopList'], resolve),
			},{
				path: 'add',
				name: 'shopAdd',
				meta:{
					bg:'bg-gray',
					title:'发布商品',
					group_key:'',
					permission_key:'product-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/shop","title":"商店"},{"url":"","title":"发布商品"}],
				},
				component: resolve => require(['@/components/shop/shopAdd'], resolve),
			},{
				path: ':id/edit',
				name: 'shopEdit',
				meta:{
					bg:'bg-gray',
					title:'编辑商品',
					group_key:'',
					permission_key:'product-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/shop","title":"商店"},{"url":"","title":"编辑商品"}],
				},
				component: resolve => require(['@/components/shop/shopEdit'], resolve),
			},{
				path: ':id/coupons',
				name: 'shopCoupons',
				meta:{
					bg:'bg-gray',
					title:'商品抵用券',
					group_key:'',
					permission_key:'product-coupons',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/shop","title":"商店"},{"url":"","title":"商品抵用券"}],
				},
				component: resolve => require(['@/components/shop/coupons/shopCoupons'], resolve),
			},{
				path: ':id/coupons/add',
				name: 'shopCouponsAdd',
				meta:{
					bg:'bg-gray',
					title:'生成商品抵用券',
					group_key:'',
					permission_key:'product-coupon-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/shop","title":"商店"},{"url":"","title":"生成商品抵用券"}],
				},
				component: resolve => require(['@/components/shop/coupons/shopCouponsAdd'], resolve),
			},{
				path: 'banner',
				name: 'shopBanner',
				meta:{
					bg:'bg-gray',
					title:'商品 Banner',
					group_key:'',
					permission_key:'shop-banners',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"商品 Banner"}],
				},
				component: resolve => require(['@/components/shop/banner/shopBanner'], resolve),
			},{
				path: 'banner/add',
				name: 'shopBannerAdd',
				meta:{
					bg:'bg-gray',
					title:'添加商品 Banner',
					group_key:'',
					permission_key:'shop-banner-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/shop/banner","title":"商品 Banner"},{"url":"","title":"添加商品 Banner"}],
				},
				component: resolve => require(['@/components/shop/banner/shopBannerAdd'], resolve),
			},{
				path: 'banner/:id/edit',
				name: 'shopBannerEdit',
				meta:{
					bg:'bg-gray',
					title:'编辑商品 Banner',
					group_key:'',
					permission_key:'shop-banner-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/shop/banner","title":"商品 Banner"},{"url":"","title":"编辑商品 Banner"}],
				},
				component: resolve => require(['@/components/shop/banner/shopBannerEdit'], resolve),
			}]
		},{
			path: '/admin/order',
			component: resolve => require(['@/components/indexModule'], resolve),
			children: [{
				path: '',
				name: 'OrderList',
				meta:{
					bg:'bg-gray',
					title:'订单',
					group_key:'',
					permission_key:'entity-orders',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"订单"}],
				},
				component: resolve => require(['@/components/order/OrderList'], resolve),
			},{
				path: ':id',
				name: 'OrderDetail',
				meta:{
					bg:'bg-gray',
					title:'订单详情',
					group_key:'',
					permission_key:'entity-order',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/order","title":"订单"},{"url":"","title":"订单详情"}],
				},
				component: resolve => require(['../components/order/OrderDetail'], resolve),
			}]
		},{
			path: '/admin/member',
			component: resolve => require(['@/components/indexModule'], resolve),
			children: [{
				path: '',
				name: 'MemberList',
				meta:{
					bg:'bg-gray',
					title:'会员列表',
					group_key:'',
					permission_key:'members',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"会员列表"}],
				},
				component: resolve => require(['@/components/member/memberList'], resolve),
			},{
				path: 'member-join',
				name: 'memberJoin',
				meta:{
					bg:'bg-gray',
					title:'添加线下付费会员',
					group_key:'',
					permission_key:'member-join',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"添加线下付费会员"}],
				},
				component: resolve => require(['@/components/member/memberJoin'], resolve),
			},{
				path: ':type/info/setting',
				name: 'memberWSPSetting',
				meta:{
					bg:'bg-gray',
					title:'WSP设置',
					group_key:'',
					permission_key:'wsp-settings',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"WSP设置"}],
				},
				component: resolve => require(['@/components/member/wsp/memberWSPSetting'], resolve),
			},{
				path: ':id/setting',
				name: 'memberSetting',
				meta:{
					bg:'bg-gray',
					title:'设置会员类型',
					group_key:'',
					permission_key:'member-settings-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/member","title":"会员列表"},{"url":"","title":"设置会员类型"}],
				},
				component: resolve => require(['@/components/member/setting/memberSetting'], resolve),
			},{
				path: 'type',
				name: 'memberType',
				meta:{
					bg:'bg-gray',
					title:'会员类型',
					group_key:'',
					permission_key:'member-types',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"}],
				},
				component: resolve => require(['@/components/member/Type/memberType'], resolve),
			},{
				path: 'type/:type/add',
				name: 'memberTypeAdd',
				meta:{
					bg:'bg-gray',
					title:'添加会员类型',
					group_key:'',
					permission_key:'member-type-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/member/type","title":"会员类型"},{"url":"","title":"添加会员类型"}],
				},
				component: resolve => require(['@/components/member/Type/memberTypeAdd'], resolve),
			},{
				path: 'type/:type/:id/edit',
				name: 'memberTypeEdit',
				meta:{
					bg:'bg-gray',
					title:'编辑会员类型',
					group_key:'',
					permission_key:'member-type-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/member/type","title":"会员类型"},{"url":"","title":"编辑会员类型"}],
				},
				component: resolve => require(['@/components/member/Type/memberTypeEdit'], resolve),
			},{
				path: ':id/address',
				name: 'userAddress',
				meta:{
					bg:'bg-gray',
					title:'收货地址',
					group_key:'',
					permission_key:'shipping-addresses',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/member","title":"会员列表"},{"url":"","title":"收货地址"}],
					type:'member',				//用户列表和会员列表都有做这个页面，此值为了区分两个列表跳转的面包屑
				},	
				component: resolve => require(['@/components/user/userAddress/userAddress'], resolve),
			},{
				path: ':uid/address/add',
				name: 'userAddressAdd',
				meta:{
					bg:'bg-gray',
					title:'新增收货地址',
					group_key:'',
					permission_key:'shipping-address-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/member","title":"会员列表"}],
					type:'member',
				},
				component: resolve => require(['@/components/user/userAddress/userAddressAdd'], resolve),
			},{
				path: ':uid/address/:aid/edit',
				name: 'userAddressEdit',
				meta:{
					bg:'bg-gray',
					title:'编辑收货地址',
					group_key:'',
					permission_key:'shipping-address-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/member","title":"会员列表"}],
					type:'member',
				},
				component: resolve => require(['@/components/user/userAddress/userAddressEdit'], resolve),
			},{
				path: ':id/invoices',
				name: 'userInvoices',
				meta:{
					bg:'bg-gray',
					title:'发票信息',
					group_key:'',
					permission_key:'invoices',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/member","title":"会员列表"},{"url":"","title":"发票信息"}],
					type:'member',
				},
				component: resolve => require(['@/components/user/userInvoices/userInvoices'], resolve),
			},{
				path: ':uid/invoice/add',
				name: 'userInvoicesAdd',
				meta:{
					bg:'bg-gray',
					title:'新增发票信息',
					group_key:'',
					permission_key:'invoice-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/member","title":"会员列表"}],
					type:'member',
				},
				component: resolve => require(['@/components/user/userInvoices/userInvoicesAdd'], resolve),
			},{
				path: ':uid/invoice/:vid/edit',
				name: 'userInvoicesEdit',
				meta:{
					bg:'bg-gray',
					title:'编辑发票信息',
					group_key:'',
					permission_key:'invoice-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/member","title":"会员列表"}],
					type:'member',
				},
				component: resolve => require(['@/components/user/userInvoices/userInvoicesEdit'], resolve),
			},{
				path: 'locker',
				name: 'memberLocker',
				meta:{
					bg:'bg-gray',
					title:'公有文件夹',
					group_key:'',
					permission_key:'member-types',			//会员类型的接口
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"公有文件夹"}],
					type:'member',
				},
				component: resolve => require(['@/components/member/memberLocker/memberLocker'], resolve),
			},{
				path: 'locker/:type',
				name: 'memberLockerDetail',
				meta:{
					bg:'bg-gray',
					title:'文件柜详情',
					group_key:'',
					permission_key:'member-locker',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"}],
					type:'member',
				},
				component: resolve => require(['@/components/member/memberLocker/memberLockerDetail'], resolve),
			},{
				path: 'locker/:type/upload',
				name: 'memberLockerUpload',
				meta:{
					bg:'bg-gray',
					title:'文件柜文件上传',
					group_key:'',
					permission_key:'member-locker-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"}],
					type:'member',
					pageUpdate:false
				},
				component: resolve => require(['@/components/member/memberLocker/memberLockerUpload'], resolve),
			},{
				path: 'private-locker-file',
				name: 'PrivateLockerFile',
				meta:{
					bg:'bg-gray',
					title:'私有文件夹',
					group_key:'',
					permission_key:'members',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"私有文件夹"}],
					type:'member',
				},
				component: resolve => require(['@/components/member/memberLocker/PrivateLockerFile'], resolve),
			},{
				path: 'private-locker-file/upload',				//私有文件上传（可以上传多名会员的）
				name: 'memberLockerUpload',
				meta:{
					bg:'bg-gray',
					title:'文件柜文件上传',
					group_key:'',
					permission_key:'member-locker-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"}],
					type:'member',
					pageUpdate:false
				},
				component: resolve => require(['@/components/member/memberLocker/memberLockerUpload'], resolve),
			},{
				path: 'private-locker-file/:uid',
				name: 'memberLockerDetail',
				meta:{
					bg:'bg-gray',
					title:'文件柜详情',
					group_key:'',
					permission_key:'member-locker',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"}],
					type:'member',
				},
				component: resolve => require(['@/components/member/memberLocker/memberLockerDetail'], resolve),
			},{
				path: 'private-locker-file/:uid/upload',
				name: 'memberLockerUpload',
				meta:{
					bg:'bg-gray',
					title:'文件柜文件上传',
					group_key:'',
					permission_key:'member-locker-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"}],
					type:'member',
				},
				component: resolve => require(['@/components/member/memberLocker/memberLockerUpload'], resolve),
			},{
				path: 'member-center/setting/info',
				name: 'memberCenterSetting',
				meta:{
					bg:'bg-gray',
					title:'会员中心设置',
					group_key:'',
					permission_key:'member-center-settings',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"会员中心设置"}],
				},
				component: resolve => require(['@/components/member/memberCenter/memberCenterSetting'], resolve),
			},{
				path: ':type/banner',
				name: 'MemberBanner',
				meta:{
					bg:'bg-gray',
					title:'',
					group_key:'',
					permission_key:'member-banners',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"}],
				},
				component: resolve => require(['@/components/member/banner/memberBanner'], resolve),
			},{
				path: ':type/banner/add',
				name: 'MemberBannerAdd',
				meta:{
					bg:'bg-gray',
					title:'',
					group_key:'',
					permission_key:'member-banner-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"}],
				},
				component: resolve => require(['@/components/member/banner/memberBannerAdd'], resolve),
			},{
				path: ':type/banner/:id/edit',
				name: 'MemberBannerEdit',
				meta:{
					bg:'bg-gray',
					title:'',
					group_key:'',
					permission_key:'member-banner-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"}],
				},
				component: resolve => require(['@/components/member/banner/memberBannerEdit'], resolve),
			},{
				path: ':uid/consumption',
				name: 'memberConsumption',
				meta:{
					bg:'bg-gray',
					title:'用户详情',
					group_key:'',
					permission_key:'member-consumption',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/member","title":"会员列表"},{"url":"","title":"用户详情"}],
				},
				component: resolve => require(['../components/member/consumption/memberConsumption'], resolve),
			},{
				path: ':uid/buy-product',
				name: 'memberBuyProduct',
				meta:{
					bg:'bg-gray',
					title:'后台下单',
					group_key:'',
					permission_key:'entity-order-create',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/member","title":"会员列表"},{"url":"","title":"后台下单"}],
					type:'member',
				},
				component: resolve => require(['../components/member/buy-product/memberBuyProduct'], resolve),
			},{
				path: ':uid/credential',
				name: 'memberCredential',
				meta:{
					bg:'bg-gray',
					title:'会员证书',
					group_key:'',
					permission_key:'member-credential',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/member","title":"会员列表"},{"url":"","title":"会员证书"}],
				},
				component: resolve => require(['../components/member/credential/memberCredential'], resolve),
			},{
				path: ':uid/credential/add',
				name: 'memberCredentialAdd',
				meta:{
					bg:'bg-gray',
					title:'上传证书',
					group_key:'',
					permission_key:'member-credential-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"}],
				},
				component: resolve => require(['@/components/member/credential/memberCredentialAdd'], resolve),
			},{
				path: ':uid/credential/:cid/edit',
				name: 'memberCredentialEdit',
				meta:{
					bg:'bg-gray',
					title:'重新上传',
					group_key:'',
					permission_key:'member-credential-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"}],
				},
				component: resolve => require(['@/components/member/credential/memberCredentialEdit'], resolve),
			},{
				path: 'learning',
				name: 'memberLearning',
				meta:{
					bg:'bg-gray',
					title:'学习数据',
					group_key:'',
					permission_key:'member-learning-data',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"学习数据"}],
				},
				component: resolve => require(['@/components/member/learning/memberLearning'], resolve),
			},{
				path: ':type/witness',
				name: 'memberWitness',
				meta:{
					bg:'bg-gray',
					title:'学员见证',
					group_key:'',
					permission_key:'member-witnesses',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"学员见证"}],
				},
				component: resolve => require(['@/components/member/witness/memberWitness'], resolve),
			},{
				path: 'witness/:type/add',
				name: 'memberWitnessAdd',
				meta:{
					bg:'bg-gray',
					title:'添加学员见证',
					group_key:'',
					permission_key:'member-witness-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/member/witness","title":"学员见证"},{"url":"","title":"添加学员见证"}],
				},
				component: resolve => require(['@/components/member/witness/memberWitnessAdd'], resolve),
			},{
				path: 'witness/:id/edit',
				name: 'memberWitnessEdit',
				meta:{
					bg:'bg-gray',
					title:'编辑学员见证',
					group_key:'',
					permission_key:'member-witness-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/member/witness","title":"学员见证"},{"url":"","title":"编辑学员见证"}],
				},
				component: resolve => require(['@/components/member/witness/memberWitnessEdit'], resolve),
			},{
				path: ':type/speeches',
				name: 'memberSpeeches',
				meta:{
					bg:'bg-gray',
					title:'学员感言',
					group_key:'',
					permission_key:'member-witnesses',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"学员见证"}],
				},
				component: resolve => require(['@/components/member/speeches/memberSpeeches'], resolve),
			},{
				path: 'speeches/:type/add',
				name: 'memberSpeechesAdd',
				meta:{
					bg:'bg-gray',
					title:'添加学员感言',
					group_key:'',
					permission_key:'member-witness-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/member/speeches","title":"学员见证"},{"url":"","title":"添加学员见证"}],
				},
				component: resolve => require(['@/components/member/speeches/memberSpeechesAdd'], resolve),
			},{
				path: 'speeches/:id/edit',
				name: 'memberSpeechesEdit',
				meta:{
					bg:'bg-gray',
					title:'编辑学员感言',
					group_key:'',
					permission_key:'member-witness-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/member/speeches","title":"学员见证"},{"url":"","title":"编辑学员见证"}],
				},
				component: resolve => require(['@/components/member/speeches/memberSpeechesEdit'], resolve),
			}]
		},{
			path: '/admin/index',
			component: resolve => require(['@/components/indexModule'], resolve),
			children: [{
				path: 'banner',
				name: 'IndexBanner',
				meta:{
					bg:'bg-gray',
					title:'首页 Banner',
					group_key:'',
					permission_key:'home-banners',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"首页Banner"}],
				},
				component: resolve => require(['@/components/Banner/index/IndexBanner'], resolve),
			},{
				path: 'banner/add',
				name: 'IndexBannerAdd',
				meta:{
					bg:'bg-gray',
					title:'添加首页 Banner',
					group_key:'',
					permission_key:'home-banner-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/index/banner","title":"首页Banner"},{"url":"","title":"添加首页 Banner"}],
				},
				component: resolve => require(['@/components/Banner/index/IndexBannerAdd'], resolve),
			},{
				path: 'banner/:id/edit',
				name: 'IndexBannerEdit',
				meta:{
					bg:'bg-gray',
					title:'编辑首页 Banner',
					group_key:'',
					permission_key:'home-banner-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/index/banner","title":"首页 Banner"},{"url":"","title":"编辑首页 Banner"}],
				},
				component: resolve => require(['@/components/Banner/index/IndexBannerEdit'], resolve),
			}]
		},{
			path: '/admin/event',
			component: resolve => require(['@/components/indexModule'], resolve),
			children: [{
				path: '',
				name: 'eventList',
				meta:{
					bg:'bg-gray',
					title:'活动列表',
					group_key:'',
					permission_key:'events',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"活动列表"}],
				},
				component: resolve => require(['@/components/event/EventList'], resolve),
			},{
				path: 'banner',
				name: 'EventBanner',
				meta:{
					bg:'bg-gray',
					title:'活动 Banner',
					group_key:'',
					permission_key:'event-banners',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"活动 Banner"}],
				},
				component: resolve => require(['@/components/event/banner/eventBanner'], resolve),
			},{
				path: 'banner/add',
				name: 'EventBannerAdd',
				meta:{
					bg:'bg-gray',
					title:'添加活动 Banner',
					group_key:'',
					permission_key:'event-banner-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/event/banner","title":"活动 Banner"},{"url":"","title":"添加活动 Banner"}],
				},
				component: resolve => require(['@/components/event/banner/eventBannerAdd'], resolve),
			},{
				path: 'banner/:id/edit',
				name: 'EventBannerEdit',
				meta:{
					bg:'bg-gray',
					title:'编辑活动 Banner',
					group_key:'',
					permission_key:'event-banner-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/event/banner","title":"活动 Banner"},{"url":"","title":"编辑活动 Banner"}],
				},
				component: resolve => require(['@/components/event/banner/eventBannerEdit'], resolve),
			},{
				path: 'add',
				name: 'eventAdd',
				meta:{
					bg:'bg-gray',
					title:'发布活动',
					group_key:'',
					permission_key:'event-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/event","title":"活动列表"},{"url":"","title":"发布活动"}],
				},
				component: resolve => require(['../components/event/edit/EventAdd'], resolve),
			},{
				path: ':id/edit',
				name: 'eventEdit',
				meta:{
					bg:'bg-gray',
					title:'活动编辑',
					group_key:'',
					permission_key:'event-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/event","title":"活动列表"},{"url":"","title":"活动编辑"}],
				},
				component: resolve => require(['../components/event/edit/eventEdit'], resolve),
			},{
				path: ':id/event-admins',
				name: 'eventAdmins',
				meta:{
					bg:'bg-gray',
					title:'活动管理员',
					group_key:'',
					permission_key:'event-admins',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/event","title":"活动列表"},{"url":"","title":"活动管理员"}],
				},
				component: resolve => require(['../components/event/admins/eventAdmins'], resolve),
			},{
				path: ':id/event-admins/add',
				name: 'eventAdminStore',
				meta:{
					bg:'bg-gray',
					title:'添加管理员',
					group_key:'',
					permission_key:'event-admin-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/course","title":"活动列表"},{"url":"","title":"活动管理员"}],
				},
				component: resolve => require(['../components/event/admins/eventAdminsAdd'], resolve),
			},{
				path: ':id/coupon',
				name: 'eventCoupon',
				meta:{
					bg:'bg-gray',
					title:'活动抵用券',
					group_key:'',
					permission_key:'event-coupons',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/event","title":"活动列表"},{"url":"","title":"活动抵用券"}],
				},
				component: resolve => require(['../components/event/coupon/eventCoupon'], resolve),
			},{
				path: ':id/event-members',
				name: 'eventMembers',
				meta:{
					bg:'bg-gray',
					title:'活动报名人员',
					group_key:'',
					permission_key:'event-members',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/event","title":"活动列表"},{"url":"","title":"活动报名人员"}],
				},
				component: resolve => require(['../components/event/member/eventMembers'], resolve),
			},{
				path: ':id/setting',
				name: 'eventSetting',
				meta:{
					bg:'bg-gray',
					title:'活动权限设置',
					group_key:'',
					permission_key:'event-setting-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/live","title":"活动列表"},{"url":"","title":"活动权限设置"}],
				},
				component: resolve => require(['../components/event/setting/eventSetting'], resolve),
			},{
				path: 'event-aides',
				name: 'eventAides',
				meta:{
					bg:'bg-gray',
					title:'活动助手',
					group_key:'',
					permission_key:'event-aides',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"活动助手"}],
				},
				component: resolve => require(['@/components/event/event-aides/EventAides'], resolve),
			},{
				path: 'event-aides/add',
				name: 'eventAides',
				meta:{
					bg:'bg-gray',
					title:'添加活动助手',
					group_key:'',
					permission_key:'event-aides',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/event/event-aides","title":"活动助手"},{"url":"","title":"添加活动助手"}],
				},
				component: resolve => require(['@/components/event/event-aides/EventAidesAdd'], resolve),
				
			}]
		},{
			path: '/admin/live',
			component: resolve => require(['@/components/indexModule'], resolve),
			children: [{
				path: '',
				name: 'liveList',
				meta:{
					bg:'bg-gray',
					title:'回放列表',
					group_key:'',
					permission_key:'events',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"回放列表"}],
				},
				component: resolve => require(['@/components/event/EventList'], resolve),
			},{
				path: ':id/coupon',
				name: 'liveCoupon',
				meta:{
					bg:'bg-gray',
					title:'回放抵用券',
					group_key:'',
					permission_key:'event-coupons',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/live","title":"回放列表"},{"url":"","title":"回放抵用券"}],
				},
				component: resolve => require(['../components/event/coupon/eventCoupon'], resolve),
			},{
				path: ':id/setting',
				name: 'liveSetting',
				meta:{
					bg:'bg-gray',
					title:'回放权限设置',
					group_key:'',
					permission_key:'event-setting-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/live","title":"回放列表"},{"url":"","title":"回放权限设置"}],
				},
				component: resolve => require(['../components/event/setting/eventSetting'], resolve),
			},{
				path: 'add',
				name: 'LiveAdd',
				meta:{
					bg:'bg-gray',
					title:'发布回放',
					group_key:'',
					permission_key:'event-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/event","title":"回放列表"},{"url":"","title":"发布回放"}],
				},
				component: resolve => require(['../components/event/edit/liveAdd'], resolve),
			}]
		},{
			path: '/admin/event-sync-member',
			component: resolve => require(['@/components/indexModule'], resolve),
			children: [{
				path: '',
				name: 'eventSyncMember',
				meta:{
					bg:'bg-gray',
					title:'同步订购名单至回放',
					group_key:'',
					permission_key:'event-sync-member',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"同步订购名单至回放"}],
				},
				component: resolve => require(['@/components/event/event-sync-member/eventSyncMember'], resolve),
			}]
		},{
			path: '/admin/flash-cards',
			component: resolve => require(['@/components/indexModule'], resolve),
			children: [{
				path: '',
				name: 'flashCardsList',
				meta:{
					bg:'bg-gray',
					title:'闪卡列表',
					group_key:'',
					permission_key:'flash-cards',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"闪卡列表"}],
				},
				component: resolve => require(['@/components/flashCards/flashCardsList'], resolve),
			},{
				path: 'add',
				name: 'flashCardsAdd',
				meta:{
					bg:'bg-gray',
					title:'添加闪卡',
					group_key:'',
					permission_key:'flash-card-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/flash-cards","title":"闪卡列表"},{"url":"","title":"添加闪卡"}],
				},
				component: resolve => require(['@/components/flashCards/flashCardsAdd'], resolve),
			},{
				path: ':id/edit',
				name: 'flashCardsEdit',
				meta:{
					bg:'bg-gray',
					title:'编辑闪卡',
					group_key:'',
					permission_key:'flash-card-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/flash-cards","title":"闪卡列表"},{"url":"","title":"编辑闪卡"}],
				},
				component: resolve => require(['@/components/flashCards/flashCardsEdit'], resolve),
			}]
		},{
			path: '/admin/flash-cards-category',
			component: resolve => require(['@/components/indexModule'], resolve),
			children: [{
				path: '',
				name: 'flashCardsCategoryList',
				meta:{
					bg:'bg-gray',
					title:'闪卡分组',
					group_key:'',
					permission_key:'flash-card-categories',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"闪卡分组"}],
				},
				component: resolve => require(['@/components/flashCards/category/flashCardsCategoryList'], resolve),
			},{
				path: 'add',
				name: 'flashCardsCategoryAdd',
				meta:{
					bg:'bg-gray',
					title:'添加闪卡分组',
					group_key:'',
					permission_key:'flash-card-category-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/flash-cards-category","title":"闪卡分组"},{"url":"","title":"添加闪卡分组"}],
				},
				component: resolve => require(['@/components/flashCards/category/flashCardsCategoryAdd'], resolve),
			},{
				path: ':id/edit',
				name: 'flashCardsCategoryEdit',
				meta:{
					bg:'bg-gray',
					title:'编辑闪卡分组',
					group_key:'',
					permission_key:'flash-card-category-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/flash-cards-category","title":"闪卡分组"},{"url":"","title":"编辑闪卡分组"}],
				},
				component: resolve => require(['@/components/flashCards/category/flashCardsCategoryEdit'], resolve),
			}]
		},{
			path: '/admin/vocation',
			component: resolve => require(['@/components/indexModule'], resolve),
			children: [{
				path: 'setting',
				name: 'vocationSetting',
				meta:{
					bg:'bg-gray',
					title:'天赋卡牌设置',
					group_key:'',
					permission_key:'vocation-settings-store',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"天赋卡牌设置"}],
				},
				component: resolve => require(['@/components/vocation/vocationSetting'], resolve),
			}]
		},{
			path: '/admin/live-audience',
			component: resolve => require(['@/components/indexModule'], resolve),
			children: [{
				path: 'topics',
				name: 'liveAudienceTopics',
				meta:{
					bg:'bg-gray',
					title:'直播主题列表',
					group_key:'',
					permission_key:'live-audience-topics',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"直播主题列表"}],
				},
				component: resolve => require(['@/components/liveAudience/liveAudienceTopicsPage.vue'], resolve),
			}]
		},{
			path: '/admin/setting',
			component: resolve => require(['@/components/indexModule'], resolve),
			children: [{
				path: 'ad',
				name: 'adSettings',
				meta:{
					bg:'bg-gray',
					title:'开机广告设置',
					group_key:'',
					permission_key:'ad-settings',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"开机广告设置"}],
				},
				component: resolve => require(['@/components/setting/adSettings'], resolve),
			},{
				path: 'live-audience-import',
				name: 'liveAudienceImportSetting',
				meta:{
					bg:'bg-gray',
					title:'导入直播观众观看记录',
					group_key:'',
					permission_key:'live-audience-import',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"导入直播观众观看记录"}],
				},
				component: resolve => require(['@/components/setting/liveAudienceImportSetting'], resolve),
			},{
				path: 'system',
				name: 'systemSetting',
				meta:{
					bg:'bg-gray',
					title:'系统设置',
					group_key:'',
					permission_key:'system-settings-store',
					menu:'settings',
					bread:[{"url":"/admin/dashboard/settings","title":"后台设置"},{"url":"","title":"系统设置"}],
				},
				component: resolve => require(['@/components/setting/systemSettings'], resolve),
			},{
				path: 'version',
				name: 'versionSetting',
				meta:{
					bg:'bg-gray',
					title:'版本号设置',
					group_key:'',
					permission_key:'system-version-settings-store',
					menu:'settings',
					bread:[{"url":"/admin/dashboard/settings","title":"后台设置"},{"url":"","title":"版本号设置"}],
				},
				component: resolve => require(['@/components/setting/versionSetting'], resolve),
			},{
				path: 'system-log',
				name: 'systemLogSetting',
				meta:{
					bg:'bg-gray',
					title:'日志设置',
					group_key:'',
					permission_key:'system-log-settings-store',
					menu:'settings',
					bread:[{"url":"/admin/dashboard/settings","title":"后台设置"},{"url":"","title":"日志设置"}],
				},
				component: resolve => require(['@/components/setting/systemLogSetting'], resolve),
			},{
				path: 'system-meta',
				name: 'systemMetaSetting',
				meta:{
					bg:'bg-gray',
					title:'meta设置',
					group_key:'',
					permission_key:'system-meta-settings-store',
					menu:'settings',
					bread:[{"url":"/admin/dashboard/settings","title":"后台设置"},{"url":"","title":"meta设置"}],
				},
				component: resolve => require(['@/components/setting/systemMetaSetting'], resolve),
			},{
				path: 'system-wallet',
				name: 'systemWalletSetting',
				meta:{
					bg:'bg-gray',
					title:'钱包设置',
					group_key:'',
					permission_key:'system-wallet-settings-store',
					menu:'settings',
					bread:[{"url":"/admin/dashboard/settings","title":"后台设置"},{"url":"","title":"钱包设置"}],
				},
				component: resolve => require(['@/components/setting/systemWalletSetting'], resolve),
			},{
				path: 'flash-card',
				name: 'flashCardsSetting',
				meta:{
					bg:'bg-gray',
					title:'闪卡配置',
					group_key:'',
					permission_key:'flash-card-setting-store',
					menu:'settings',
					bread:[{"url":"/admin/dashboard/settings","title":"后台设置"},{"url":"","title":"闪卡配置"}],
				},
				component: resolve => require(['@/components/flashCards/setting/flashCardsSetting'], resolve),
			}]
		},{
			path: '/admin/tags',
			component: resolve => require(['@/components/indexModule'], resolve),
			children: [{
				path: '',
				name: 'TgasList',
				meta:{
					bg:'bg-gray',
					title:'标签',
					group_key:'',
					permission_key:'tags',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"","title":"标签"}],
				},
				component: resolve => require(['@/components/tag/TagsList'], resolve),
			},{
				path: ':id/tag-entities',
				name: 'TagEntities',
				meta:{
					bg:'bg-gray',
					title:'标签实体',
					group_key:'',
					permission_key:'tag-entities',
					menu:'operation',
					bread:[{"url":"/admin/dashboard/operation","title":"运营管理"},{"url":"/admin/tags","title":"标签"},{"url":"","title":"标签对应实体"}],
				},
				component: resolve => require(['@/components/tag/TagEntities'], resolve),
			}]
		},{
			path: '/admin/helper',
			component: resolve => require(['@/components/indexModule'], resolve),
			children: [{
				path: '',
				name: 'helperPage',
				meta:{
					bg:'bg-gray',
					title:'帮助',
					menu:'helper',
				},
				component: resolve => require(['@/components/helper/helperPage'], resolve),
			}]
		},{
			path: '/admin/doc',
			component: resolve => require(['@/components/indexModule'], resolve),
			children: [{
				path: '',
				name: 'DocListPage',
				meta:{
					bg:'bg-gray',
					title:'文档',
					menu:'doc',
					permission_key:'docs',
				},
				component: resolve => require(['@/components/doc/DocList'], resolve),
			},{
				path: 'add',
				name: 'DocAddPage',
				meta:{
					bg:'bg-gray',
					title:'创建文档',
					permission_key:'doc-store',
					menu:'doc',
					bread:[{"url":"/admin/doc","title":"文档"},{"url":"","title":"创建文档"}],
				},
				component: resolve => require(['@/components/doc/DocAdd'], resolve),
			},{
				path: ':id',
				name: 'DocDetailPage',
				meta:{
					bg:'bg-gray',
					title:'文档详细',
					permission_key:'doc',
					menu:'doc',
					bread:[{"url":"/admin/doc","title":"文档"}],
				},
				component: resolve => require(['@/components/doc/DocDetail'], resolve),
			},{
				path: ':id/edit',
				name: 'DocEditPage',
				meta:{
					bg:'bg-gray',
					title:'编辑文档',
					permission_key:'doc-store',
					menu:'doc',
					bread:[{"url":"/admin/doc","title":"文档"},{"url":"","title":"编辑文档"}],
				},
				component: resolve => require(['@/components/doc/DocEdit'], resolve),
			}
//			,{
//				path: 'add/editor',
//				name: 'EditorAdd',
//				meta:{
//					bg:'bg-gray',
//					title:'',
//					permission_key:'doc-store',
//					menu:'doc',
//					bread:[{"url":"/admin/doc","title":"文档"},{"url":"","title":"编辑文档"}],
//				},
//				component: resolve => require(['@/components/doc/EditorAdd'], resolve),
//			}
			]
		},{
			path: "*",
			name: 'errorPage',
			component: resolve => require(['@/components/errorPage'], resolve),
		}]
	}]
})


// WEBPACK FOOTER //
// ./src/router/index.js